import { LoginFormData } from "../types/loginFormData";
import axiosInstance from "@/lib/axiosInterceptor";
import { Result } from "types/result";

interface Data {
    access_token: string;
    email: string;
}

interface UserData {
    id: string;
    email: string;
    roles: string[];
}

interface LoginAsUserResponse {
    access_token: string;
    email: string;
}

export const loginFn = async (formData: LoginFormData): Promise<Result<Data>> => {
    try {
        const response = await axiosInstance.post<Data>(
            `${process.env.NEXT_PUBLIC_ACCOUNT_SERVER_URL}/auth/login`,
            formData,
        );
        return {
            data: response.data,
            error: null,
        };
    } catch (e: any) {
        return {
            data: null,
            error: {
                messageKey: e.response.data.response.messageKey,
                message: e.response.data.response.message || e.message,
                data: e.response.data.response.data,
            },
        };
    }
};

export const fetchUserData = async (): Promise<Result<UserData>> => {
    try {
        const response = await axiosInstance.get<UserData>(
            `${process.env.NEXT_PUBLIC_ACCOUNT_SERVER_URL}/auth/me`
        );
        return {
            data: response.data,
            error: null,
        };
    } catch (e: any) {
        return {
            data: null,
            error: {
                messageKey: e.response?.data?.response?.messageKey || 'error',
                message: e.response?.data?.response?.message || e.message,
            },
        };
    }
};

export const loginAsUser = async (email: string) => {
    try {
        const response = await fetch(`${process.env.NEXT_PUBLIC_ACCOUNT_SERVER_URL}/admin/auth/login-as-user`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ email })
        });

        const data = await response.json();
        
        if (!response.ok) {
            return { error: { message: data.message || "Failed to login as user" } };
        }

        return { data };
    } catch (error: any) {
        return { error: { message: error.message || "Failed to login as user" } };
    }
};
